import { ReactElement, useEffect } from 'react';
import { Component as CartIcon } from 'icons/icon-ui--cart-small.svg';
import { useCart } from 'contexts/Cart';
import useSaveCart from '../../hooks/useSaveCart';

type Props = {
  isLtoMenuUnskipped: boolean;
  isReactivatedUser: boolean;
  isEditCartPage?: boolean;
};
function LTOBannerAddToCartButton({
  isLtoMenuUnskipped,
  isReactivatedUser,
  isEditCartPage,
} : Props): ReactElement {
  const { dispatch, cart } = useCart();
  const saveCart = useSaveCart();
  const ltoBoxSku = cart?.menu_items
    ?.map((menuItem) => menuItem.sku)
    .find((mappedSku) => mappedSku?.is_lto_box === true);
  const skuId = ltoBoxSku?.id;
  const skuQty = cart?.menu_items?.find((m) => m.sku?.is_lto_box)?.quantity;
  const linkWithCartId = `/menus/${cart.menu_id}/carts/${cart.id}/edit?back_drawer_open=true`;

  const setQuantity = (qty) => {
    if (skuId !== undefined) {
      dispatch({
        type: 'setMenuItemQuantity',
        quantity: qty,
        skuId,
      });
      saveCart();
    }
  };

  const onAddToCart = async () => {
    if (skuQty === 0) {
      localStorage.setItem('showButton', 'false');
      setQuantity(1);
    }
    // if on edit cart just open summary, if not nav to cart
    if (isEditCartPage) {
      dispatch({
        type: 'toggleSummaryVisible',
        isSummaryVisible: true,
      });
    } else {
      // Wrapping redirect in a timeout because during testing
      // payload had not yet been constructed and sent to update cart
      // endpoint.
      setTimeout(() => {
        window.location.href = linkWithCartId;
      },
      300);
    }
  };

  // if unskipping action is complete (i.e. cart is reloaded with original items),
  // then we can proceed with adding the LTO item to the cart
  useEffect(() => {
    if (isLtoMenuUnskipped || isReactivatedUser) {
      onAddToCart();
    }
  }, [isLtoMenuUnskipped, isReactivatedUser]);

  return (
    <button
      type="button"
      className="c-upcoming-menu__thanksgivingBanner__addtoCartButton"
      style={isEditCartPage ? { paddingBottom: '12px' } : {}}
      onClick={onAddToCart}
    >
      <CartIcon />
      {skuQty === 0 ? <span>Add to Cart</span> : (<span>In Your Cart</span>)}
    </button>
  );
}

export default LTOBannerAddToCartButton;
